
import { ChipItem, ParamBetTXCB, PayloadBodyUserQueueTXCB, StoreBetTXCB } from 'models/txcb-model';
import { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import './board-xd.scss';
import ReactDOMServer from 'react-dom/server';
import {
    
} from 'models/mini-xd-model';
import { ConfirmMoneyMiniXD,
    CountMoneyMiniXD,
    CountUserBetXD,
    ParamBetMiniXD,
    PayloadBodyTopicXD,
    TypePlaceMiniXD,
    ValueMoneyBetMiniXD, } from 'models/mini-xd-model';
import PlaceBetXd from '../place-bet-xd/place-bet-xd';
import PlateBowXD from '../plate-bow-xd';
import xdFunction from '../xd-function';
import { SwiperClass } from 'swiper/react';
import { chipMiniGameList, reloadBalance } from 'utils/function';
import { FaWallet } from 'react-icons/fa6';
import bgAudio from 'assets/images/audio/background.mp3';
import bgAudioStart from 'assets/images/audio/voiceStartBet.mp3';
import bgAudioStop from 'assets/images/audio/voiceStopBet.mp3';
import ChipsXocdia from '../chips-xocdia';

interface Props {
    balance: string;
    bodyTopic: PayloadBodyTopicXD;
    userQueue: PayloadBodyUserQueueTXCB;
    onBet: (action: string, payload: ParamBetMiniXD) => void;
    onUpdatePhien: (value: { id: string; result: number[] }[]) => void;
    lspData: { id: string; result: number[] }[];
    isMuted: boolean;
    onChangeMsg: (inputData: string) => void;
}
function BoardXD(props: Props, ref: any) {
    const { balance, bodyTopic, userQueue, onBet, onUpdatePhien, lspData, isMuted, onChangeMsg } = props;
    let chipStoreBet = useRef<HTMLSpanElement[]>([]);
    let objAudio = useMemo(() => new Audio(), []);
    const backgroundAudio = useMemo(() => new Audio(bgAudio), []);

    let paramsBet: ParamBetMiniXD = useMemo(
        () => ({
            xocdiaId: 0,
            even: 0,
            odd: 0,
            one_white_three_red: 0,
            three_white_one_red: 0,
            white: 0,
            red: 0,
            userId: 0,
            loginname: '',
            total_amount: 0,
            userType: 0,
            betfrom: 0,
        }),
        []
    );

    const timerFinishRef = useRef<HTMLDivElement>(null);
    const chipsListRef = useRef<any[]>([]);
    const swiperRef = useRef<SwiperClass>();
    const isNextPhien = useRef(false);

    const [timerCount, setTimerCount] = useState('00');
    const [timerFinish, setTimerFinish] = useState('');
    const [issue, setIssue] = useState(0);

    const [result, setResult] = useState<string[] | null>(null); // phiên cược
    const [chipValue, setChipValue] = useState(1000);

    const [dealerState, setDealerState] = useState<'STOP' | 'START' | ''>('');

    const [tkBoardList, setTkBoardList] = useState<{ id: string; result: number[] }[]>([]);

    const [moneyCountPlace, setMoneyCountPlace] = useState({} as CountMoneyMiniXD); // tổng cược của từng cửa
    const [countUsetBet, setCountUserBet] = useState({} as CountUserBetXD); // user cược các cửa

    const moneyWin = useRef<number>(0);
    const isShowingWin = useRef(false);

    const updateMoneyWin = (value: number) => {
        moneyWin.current = value;
    };

    const [countConfirmBet, setCountConfirmBet] = useState({
        moneyConfirmEven: 0,
        moneyConfirmOdd: 0,
        moneyConfirmRed: 0,
        moneyConfirmWhite: 0,
        moneyConfirm3White: 0,
        moneyConfirm3Red: 0,
    } as ConfirmMoneyMiniXD); //tiền đã cược của tôi các cửa
    const [totalCurrentBet, setTotalCurrentBet] = useState(0);

    useEffect(() => {
        if (isMuted) {
            backgroundAudio.pause();
        } else {
            backgroundAudio.play();
            backgroundAudio.volume = 0.5;
            backgroundAudio.loop = true;
        }
    }, [isMuted]);

    useEffect(() => {
        backgroundAudio.play();
        backgroundAudio.volume = 0.5;
        backgroundAudio.loop = true;

        return () => backgroundAudio.pause();
    }, []);

    useEffect(() => {
        //bắt đầu phiên mới
        if (bodyTopic.cmd === 1) {
            paramsBet.xocdiaId = bodyTopic.id;

            setResult(null);
            setIssue(bodyTopic.id);
            setTimerFinish('');

            setMoneyCountPlace({
                moneyCountEven: bodyTopic.aEven,
                moneyCountOdd: bodyTopic.aOdd,
                moneyCountWhite: bodyTopic.aWhite,
                moneyCountRed: bodyTopic.aRed,
                moneyCount3Red: bodyTopic.a1White3Red,
                moneyCount3White: bodyTopic.a3White1Red,
            });

            setCountUserBet({
                userEven: bodyTopic.uEven,
                userOdd: bodyTopic.uOdd,
                userWhite: bodyTopic.uWhite,
                userRed: bodyTopic.uRed,
                user3Red: bodyTopic.u1White3Red,
                user3White: bodyTopic.u3White1Red,
            });

            //thời gian cược
            setTimerCount(`0${bodyTopic.cd}`.slice(-2));
        }

        //kết quả phiên và hiệu ứng mở thưởng
        if (bodyTopic.cmd === 5 && bodyTopic.cd === -1) {
            dealerSpeak('STOP');
            let hisPhien = lspData;
            const lspLast = { id: bodyTopic['id'], result: bodyTopic['rs'] || [] };
            // hisPhien = [lspLast, ...hisPhien];
            hisPhien.pop();
            onUpdatePhien(hisPhien);
            setResult(bodyTopic.result.split('|'));
        }

        //count finish phiên
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 14) {
            setTimerFinish(`0${bodyTopic.cd}`.slice(-2));
            if (timerFinishRef.current) {
                timerFinishRef.current.style.transform = 'scale(1.25)';
                setTimeout(() => {
                    if (timerFinishRef.current) {
                        timerFinishRef.current.style.transform = 'scale(1)';
                    }
                }, 160);
            }
            if (bodyTopic.cd === 0) {
                // toast.success('Bắt đầu phiên mới');
                dealerSpeak('START');
                setCountConfirmBet({
                    moneyConfirmEven: 0,
                    moneyConfirmOdd: 0,
                    moneyConfirmRed: 0,
                    moneyConfirmWhite: 0,
                    moneyConfirm3White: 0,
                    moneyConfirm3Red: 0,
                });

                updateMoneyWin(0);
                isShowingWin.current = false;
            }
        }
        isNextPhien.current = false;
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 17) {
            isNextPhien.current = true;
        }
    }, [bodyTopic]);

    useEffect(() => {
        if (userQueue.cmd === 3) {
            //bắt đầu cược
            if (userQueue.status === 0) {
                handleGetMsg('Đặt cược thành công');
                setCountConfirmBet((value) => {
                    return {
                        moneyConfirm3Red: (value.moneyConfirm3Red += paramsBet.one_white_three_red),
                        moneyConfirm3White: (value.moneyConfirm3White += paramsBet.three_white_one_red),
                        moneyConfirmEven: (value.moneyConfirmEven += paramsBet.even),
                        moneyConfirmOdd: (value.moneyConfirmOdd += paramsBet.odd),
                        moneyConfirmRed: (value.moneyConfirmRed += paramsBet.red),
                        moneyConfirmWhite: (value.moneyConfirmWhite += paramsBet.white),
                    };
                });
                if (ref.current) {
                    chipStoreBet.current = Array.from(ref.current.querySelectorAll('.chipEmbed'));
                }
                resetBet();
                reloadBalance();
            }
        }

        // START return money win if has betting
        if (userQueue.cmd === 4 && userQueue.amount > 0 && !isShowingWin.current) {
            isShowingWin.current = true;
    
            setTimeout(() => {
                updateMoneyWin(userQueue.amount);
                setTimeout(() => {
                    updateMoneyWin(0);
                }, 3000)
            }, 2500);
        }

        //bắt đầu lịch sử phiên
        if (userQueue.cmd === 6) {
            const listHisPhien = userQueue.data
                .filter((item) => item.result !== null)
                .map((item) => {
                    return {
                        id: item['id'],
                        result: item['result'].split('').map(Number),
                    };
                })
                .slice(0, 75);
            onUpdatePhien(listHisPhien);

            const listDotHisPhien: { id: string; result: number[] }[] = JSON.parse(JSON.stringify(listHisPhien))
                .filter((_: any, idx: number) => idx < 10)
                .reverse();
            setTkBoardList(listDotHisPhien);
        }
    }, [userQueue]);

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };

    const renderHTMLChip = (item: ChipItem) => {
        return (
            <div style={{ cursor: 'unset' }} className="chip-item">
                <img src={require(`assets/images/chips/${item.icon}`)} alt="" />
                <p>{item.txt}</p>
            </div>
        );
    };

    const selectChip = (chipSelect: ChipItem) => {
        setChipValue(chipSelect.val);
    };

    const selectTypeBet = (placeEl: HTMLButtonElement, typeBet: TypePlaceMiniXD) => {
        xdFunction.playClick(objAudio);
        if (isNextPhien.current) {
            handleGetMsg('Phiên mới chưa bắt đầu');
            return;
        }
        if (totalCurrentBet + chipValue > Number(balance)) {
            handleGetMsg('Số dư không đủ');
            return;
        }

        setTotalCurrentBet((value) => (value += chipValue));

        const chipSelect = chipMiniGameList.find((item) => item.val === chipValue);
        const chipIdxSelect = chipMiniGameList.findIndex((item) => item.val === chipValue);
        if (swiperRef.current) {
            swiperRef.current.slideTo(chipIdxSelect);
        }
        if (chipSelect) {
            //chip effect bet
            const chipCloneJXS = renderHTMLChip(chipSelect);
            const htmlString = ReactDOMServer.renderToStaticMarkup(chipCloneJXS);
            if (ref.current) {
                xdFunction.effectChipBet(htmlString, ref.current, chipsListRef.current, placeEl, typeBet, chipSelect.val, 0.7);
            }
        }

        if (typeBet === '3white1red') {
            paramsBet['three_white_one_red'] += chipValue;
        } else if (typeBet === '1white3red') {
            paramsBet['one_white_three_red'] += chipValue;
        } else {
            paramsBet[typeBet] += chipValue;
        }

        paramsBet.betfrom = 3;
        const totalAmount =
            paramsBet.even +
            paramsBet.odd +
            paramsBet.one_white_three_red +
            paramsBet.three_white_one_red +
            paramsBet.white +
            paramsBet.red;
        paramsBet.total_amount = totalAmount;
    };

    const cancelBet = () => {
        xdFunction.playClick(objAudio);
        resetBet();
    };

    const rebet = () => {
        xdFunction.playClick(objAudio);
        const newMoneyCountPlace: CountMoneyMiniXD = JSON.parse(JSON.stringify(moneyCountPlace));
        let totalBet = 0;
        chipStoreBet.current.forEach((item) => {
            const keyTypeBet = item.dataset.typebet;
            const chipValueText = item.querySelector('ion-text')?.innerHTML;

            let chipValue = 0;
            if (chipValueText) {
                if (chipValueText.includes('K')) {
                    chipValue = Number(chipValueText.replace('K', '')) * 1000;
                } else if (chipValueText.includes('M')) {
                    chipValue = Number(chipValueText.replace('M', '')) * 1000000;
                }
            }

            if (keyTypeBet === 'even') {
                paramsBet.even += chipValue;
                newMoneyCountPlace.moneyCountEven += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'odd') {
                paramsBet.odd += chipValue;
                newMoneyCountPlace.moneyCountOdd += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'white') {
                paramsBet.white += chipValue;
                newMoneyCountPlace.moneyCountWhite += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'red') {
                paramsBet.red += chipValue;
                newMoneyCountPlace.moneyCountRed += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === '3white1red') {
                paramsBet.three_white_one_red += chipValue;
                newMoneyCountPlace.moneyCount3White += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === '1white3red') {
                paramsBet.one_white_three_red += chipValue;
                newMoneyCountPlace.moneyCount3Red += chipValue;
                totalBet += chipValue;
            }
        });

        setTotalCurrentBet(totalBet);
        setMoneyCountPlace(newMoneyCountPlace);

        chipStoreBet.current.forEach((item) => {
            if (ref.current) {
                const elBtnTypeBet: HTMLButtonElement = ref.current.querySelector(`[data-infinity="${item.dataset.typebet}"]`);
                elBtnTypeBet.appendChild(item);
            }
        });
    };

    const betting = () => {
        xdFunction.playClick(objAudio);
        if (isNextPhien.current) {
            handleGetMsg('Phiên mới chưa bắt đầu');
            return;
        }
        if (totalCurrentBet === 0) {
            handleGetMsg('Vui lòng chọn cửa cược');
            return;
        }
        onBet('/topic/xd/bet', JSON.parse(JSON.stringify(paramsBet)));
    };

    const resetBet = async () => {
        setTotalCurrentBet(0);
        paramsBet.even = 0;
        paramsBet.odd = 0;
        paramsBet.one_white_three_red = 0;
        paramsBet.three_white_one_red = 0;
        paramsBet.white = 0;
        paramsBet.red = 0;

        //clear chip dom
        if (ref.current) {
            const listCurrentChip = Array.from(ref.current.querySelectorAll('.chipEmbed'));
            listCurrentChip.forEach((element: any) => {
                element.remove();
            });
        }
    };

    const dealerSpeak = (type: 'START' | 'STOP') => {
        setDealerState(type);
        if (!isMuted) {
            if (type === 'START') {
                xdFunction.dealerSpeak(objAudio, bgAudioStart);
            } else {
                xdFunction.dealerSpeak(objAudio, bgAudioStop);
            }
        }
        setTimeout(() => {
            setDealerState('');
        }, 1600);
    };

    return (
        <div className="board-container">

            <div className={`moneyWin ${moneyWin.current !== 0 ? "showMoney" : ""}`} >
                <span>+{moneyWin.current.toLocaleString()}</span>
            </div>

            <div className="table-bet">
                <div className="dealer-voice">
                    <div className="voice-inner">
                        {dealerState === 'START' && <img src={require(`assets/images/mini-xd/start-bet.png`)} alt=''/>}
                        {dealerState === 'STOP' && <img src={require(`assets/images/mini-xd/stop-bet.png`)} alt=''/>}
                    </div>
                </div>
                <img className="table-img" src={require(`assets/images/mini-xd/table.png`)} />
                <div className="bet-content">
                    <div className="money-bet">
                        <div className="wallet-xd">
                            <div className="balance">
                                <FaWallet size={12} color="white" />
                                <p className="text-gradient">{new Intl.NumberFormat().format(Number(balance || 0))}</p>
                            </div>
                        </div>
                        <div></div>
                        <div className="wallet-xd">
                            <p className="text-gradient issue">#{issue}</p>
                        </div>
                    </div>
                    <div className="place-bet-wrap">
                        <div className="plate-bow">
                            <PlateBowXD result={result} timerCount={timerCount} timerFinish={timerFinish} />
                        </div>
                        <PlaceBetXd
                            moneyCount={moneyCountPlace}
                            countUser={countUsetBet}
                            moneyConfirm={countConfirmBet}
                            issue={issue}
                            result={result}
                            onSelectBet={selectTypeBet}
                        />
                    </div>
                </div>
            </div>

            <div className="chips-minigame">
                <ChipsXocdia ref={chipsListRef} valueActive={chipValue} onSelect={selectChip} />
            </div>

            <div className="footer-action">
                <div className="footer-gird">
                    <div className="footer-row">
                        <div className="footer-col">
                            <button className="btn-reset btn-action" onClick={cancelBet}>
                                <img className="action-icon" src={require(`assets/images/mini-xd/btn-clear.png`)} />
                            </button>
                        </div>
                        <div className="footer-col footer-bet">
                            <button className="btn-reset btn-bet" onClick={betting}>
                                <p>
                                    CƯỢC: <span>{new Intl.NumberFormat().format(totalCurrentBet)}</span>
                                </p>
                            </button>
                        </div>
                        <div className="footer-col">
                            <button className="btn-reset btn-action" onClick={rebet}>
                                <img className="action-icon" src={require(`assets/images/mini-xd/btn-rebet.png`)} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(BoardXD);
